
import { defineComponent } from "vue";
import { Back as CommonBack } from "@/components";

export default defineComponent({
    components: {
        CommonBack
    }
});
